import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function BrandManufacturer ({
  localBrandManufacturer,
  setLocalBrandManufacturer,
  isQueryLoading
}) {
  const handleManufacturerChange = event => {
    setLocalBrandManufacturer(event.target.value)
  }

  return (
    <div className={styles.brandContainer}>
      <div className={styles.inlineLabel}>
        <label className={styles.brandLabel} htmlFor='BrandManufacturer'>
          Brand or manufacturer
        </label>
        <Tooltip
          title='Filter by the product’s brand or manufacturer.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Brand or manufacturer help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.brandInput}
        disabled={isQueryLoading}
        placeholder='Text'
        onChange={handleManufacturerChange}
        value={localBrandManufacturer}
        type='text'
      />
    </div>
  )
}

export default BrandManufacturer
